import React, { useEffect, useState } from 'react';
import {
  buildResultTemplatesManager,
  ResultTemplate,
  Result,
  SearchEngine
} from '@coveo/headless';

import { ExtendedWindowType, headlessEngineModal } from '../../engine';
import {
  fieldsToInclude,
  fieldsObjectModal
} from '../../controllers/controller';
import Contractor from './contractor';
import { ContractorCheckboxProps, ResultListContractorProps } from './types';
import Loader from '../../../react-components/listing-states/loader';

type ContractorCheckboxResultProps = Result & ContractorCheckboxProps;

function ResultListContractor({
  formData,
  handleChange,
  controller,
  copy,
  contractorId,
  reviewName,
  certificationsCardLabel,
  viewAllCertificationsLabel,
  certificationsModalId
}: ResultListContractorProps) {
  const { dataset } = document.getElementsByClassName(
    'coveo-listing__data-wrapper-modal'
  )[0] as HTMLElement;
  const loaderText = dataset.loaderText as string;
  const [state, setState] = useState(controller.state);

  useEffect(() => {
    controller.subscribe(() => setState(controller.state));
  }, []);

  const resultTemplatesManager = buildResultTemplatesManager(
    headlessEngineModal as SearchEngine
  );

  const RequestAQuoteContractorTemplate: ResultTemplate = {
    conditions: [],
    fields: ['UniqueId', 'Uri', ...fieldsToInclude],
    content: (result: ContractorCheckboxResultProps) => {
      (window as ExtendedWindowType).dataLayer.push({
        event_attributes: {
          contractor_id: result.raw[fieldsObjectModal.contractorId],
          contractor_name: result.raw[fieldsObjectModal.contractorName],
          contractor_certificates_count: (
            ((result.raw[fieldsObjectModal.contractorType] as string)?.toLowerCase() === 'residential'
              ? result.raw[fieldsObjectModal.contractorCertificationsResidential]
              : result.raw[fieldsObjectModal.contractorCertificationsCommercial]) as string[]
          )?.length,
          contractor_rating: parseFloat(
            result.raw[fieldsObjectModal.rating] as string
          ),
          contractor_reviews_count:
            result.raw[fieldsObjectModal.numberOfReviews],
          contractor_certificate_name: (
            ((result.raw[fieldsObjectModal.contractorType] as string)?.toLowerCase() === 'residential'
              ? result.raw[fieldsObjectModal.contractorCertificationsResidential]
              : result.raw[fieldsObjectModal.contractorCertificationsCommercial]) as string[]
          )?.[0],
          contractor_type: result.raw[fieldsObjectModal.contractorType]
        },
        event: 'contractor_leads',
        event_category: 'find a contractor',
        event_action: 'contractor leads',
        event_label: ''
      });

      return (
        <Contractor
          formData={formData}
          handleChange={handleChange}
          key={result.uniqueId}
          review={{
            name: reviewName,
            contractorDBA: result.raw[
              fieldsObjectModal.contractorDBA
            ] as string,
            contractorName: result.raw[
              fieldsObjectModal.contractorName
            ] as string,
            city: result.raw[fieldsObjectModal.city] as string,
            state: result.raw[fieldsObjectModal.state] as string,
            distance: result.raw[
              fieldsObjectModal.distanceInMiles
            ] as string,
            rating: parseFloat(result.raw[fieldsObjectModal.rating] as string),
            numberOfReviews: result.raw[
              fieldsObjectModal.numberOfReviews
            ] as string,
            id: result.raw[fieldsObjectModal.contractorId] as string,
            image: result.raw[fieldsObjectModal.image] as string,
            imageAlt: result.raw[fieldsObjectModal.imageAlt] as string
          }}
          certifications={{
            title: certificationsCardLabel,
            certificates: ((result.raw[fieldsObjectModal.contractorType] as string)?.toLowerCase() === 'residential'
              ? result.raw[fieldsObjectModal.contractorCertificationsResidential]
              : result.raw[fieldsObjectModal.contractorCertificationsCommercial]) as string[],
            viewAllCertificationsLabel: viewAllCertificationsLabel
          }}
          modalId={certificationsModalId}
        ></Contractor>
      );
    }
  };

  resultTemplatesManager.registerTemplates(RequestAQuoteContractorTemplate);

  if (state.isLoading || !state.firstSearchExecuted) {
    return <Loader loaderText={loaderText} />;
  }

  let contractorNumber = 0;
  return (
    <>
      {state.results?.length > 0 ? (
        <>
          {state.results?.map(result => {
            if (result.raw[fieldsObjectModal.contractorId] === contractorId)
              return null;
            if (contractorNumber === 3) return null;
            contractorNumber++;
            const template = resultTemplatesManager.selectTemplate(
              result
            ) as CallableFunction;

            if (!template)
              throw new Error(
                `No result template provided for ${result.title}.`
              );

            return template(result);
          })}
        </>
      ) : (
        <p className="request-a-quote__card-copy ">{copy}</p>
      )}
    </>
  );
}

export default ResultListContractor;
